import { render, staticRenderFns } from "./IosLocationAccessInstructions.vue?vue&type=template&id=3738004a&scoped=true&"
import script from "./IosLocationAccessInstructions.vue?vue&type=script&lang=js&"
export * from "./IosLocationAccessInstructions.vue?vue&type=script&lang=js&"
import style0 from "./IosLocationAccessInstructions.vue?vue&type=style&index=0&id=3738004a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738004a",
  null
  
)

export default component.exports